import { render } from "./SharePostModal.vue?vue&type=template&id=67079a5e&scoped=true"
import script from "./SharePostModal.vue?vue&type=script&lang=js"
export * from "./SharePostModal.vue?vue&type=script&lang=js"

import "./SharePostModal.vue?vue&type=style&index=0&id=67079a5e&lang=scss&scoped=true"

import exportComponent from "/opt/karibu-hrms/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67079a5e"]])

export default __exports__